// front/src/components/projects/ProjectVideos.jsx
export default function ProjectVideos({ videos }) {
  if (!videos || videos.length === 0) return null;

  return (
    <section className="mb-4">
      <h2 className="h5 mb-3">Videos</h2>
      <div className="row g-3">
        {videos.map((url, i) => (
          <div key={url} className="col-12">
            {/* اگر URL یوتیوب باشد */}
            {url.includes('youtube.com') || url.includes('youtu.be') ? (
              <div className="ratio ratio-16x9">
                <iframe
                  src={url}
                  title={`Project video ${i + 1}`}
                  allowFullScreen
                />
              </div>
            ) : (
              <video
                controls
                className="w-100 rounded border"
                style={{ maxHeight: '400px' }}
              >
                <source src={url} />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
